import axiosInstance from "../axiosInstance";

export const getDashboardService = async () => {
    const response = await axiosInstance.get('/wealth/get-dashboard');
    return response.data;
};